export const MissingSignatureErrorMessage = "Missing signature. Please sign.";
export default class MissingSignatureError extends Error {
	constructor() {
		super(MissingSignatureErrorMessage);
		Object.setPrototypeOf(this, new.target.prototype);
	}
}
